import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { immerable, produce } from 'immer';

import dayjs from '../../core/configs/dayjs';
import { DcRouteUrlBuilder } from '../../core/utils/dc-route-url-builder';
import { GroupingTagProject } from './grouping-tag.types';

type GroupingTagProjectRef = GroupingTagProject & { url?: string };

interface IGroupingTagItemEntity {
	id: string;
	label: string;
	color: string;
	referencedByCount: number;
	projects: Array<GroupingTagProjectRef>;
	createdBy: string;
	createdByAvatar: AvatarEntity | null;
	createdOn: dayjs.Dayjs | null;
}

const entityDefaults: IGroupingTagItemEntity = {
	id: '-1',
	label: '',
	color: '#00000',
	referencedByCount: 0,
	projects: [],
	createdBy: '',
	createdByAvatar: null,
	createdOn: null,
};

export class GroupingTagItemEntity implements IGroupingTagItemEntity {
	private [immerable] = true;

	public id = entityDefaults.id;
	public label = entityDefaults.label;
	public color = entityDefaults.color;
	public referencedByCount = entityDefaults.referencedByCount;
	public projects = entityDefaults.projects;
	public createdBy = entityDefaults.createdBy;
	public createdByAvatar = entityDefaults.createdByAvatar;
	public createdOn = entityDefaults.createdOn;

	public static build(
		params: Partial<IGroupingTagItemEntity> = {}
	): GroupingTagItemEntity {
		const instance = new GroupingTagItemEntity();

		instance.id = params.id ?? entityDefaults.id;
		instance.label = params.label ?? entityDefaults.label;
		instance.color = params.color ?? entityDefaults.color;
		instance.referencedByCount =
			params.referencedByCount ?? entityDefaults.referencedByCount;
		instance.projects = params.projects ?? entityDefaults.projects;
		instance.createdBy = params.createdBy ?? entityDefaults.createdBy;
		instance.createdOn = params.createdOn ?? entityDefaults.createdOn;

		if (params.createdBy) {
			instance.createdByAvatar = AvatarEntity.build(params.createdBy);
		}

		return instance;
	}

	public setReferencedByCount(count: number): GroupingTagItemEntity {
		return produce(this, (draft: GroupingTagItemEntity) => {
			draft.referencedByCount = count;
		});
	}

	public setProjects(
		projects: Array<GroupingTagProject>
	): GroupingTagItemEntity {
		return produce(this, (draft: GroupingTagItemEntity) => {
			draft.projects = projects.map((p) => ({
				id: p.id,
				label: p.label,
				url: DcRouteUrlBuilder.buildProjectHomePageUrl(p.id, 'GD'),
			}));
		});
	}
}
